<script setup>
import { ref } from 'vue';

import EditModelValues from '@/Components/Models/Organisation/EditModelValues.vue';

const props = defineProps({
	organisation: {
		type: Object,
		required: true,
	},
    errors: {
        type: Object,
		required: true,
    },
    app: {
        type: Object,
		required: true,
    },
	user: {
		type: Object,
		required: true,
	},
	
})

const localOrganisation = ref(props.organisation)

const emit = defineEmits([
	'create:organisations',
]);

function createOrganisation() {
    emit('create:organisations', localOrganisation)
}
</script>

<template>
    <form @submit.prevent="createOrganisation" class="w-full">
        <SectionCard title="Add a new Member Organisation">
            <template #default>
                <EditModelValues
					:organisation="localOrganisation"
					:errors="errors"
					:app="app"
					@update:organisation="createOrganisation"
				/>
            </template>

            <template #footer>
                <div class="flex grow content-end justify-end">
                    <div class="flex self-end">
                        <Button @click="createOrganisation" class="block" color="blue">Create Organisation</Button>
                    </div>
                </div>
            </template>
                

        </SectionCard>
    </form>
</template>